import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  last?: boolean;
}

const SvgFirstLastArrow: React.FC<Props> = ({ last = false }) => {
  const isRtl = useIsRtl();
  const flip = (last && !isRtl) || (!last && isRtl);
  return (
    <svg
      style={
        flip ? { WebkitTransform: "scaleX(-1)", transform: "scaleX(-1)" } : {}
      }
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.82549 1.99284C3.693 1.99491 3.56674 2.04949 3.47446 2.14458C3.38217 2.23967 3.3314 2.36751 3.3333 2.50001V13.5C3.33237 13.5663 3.34461 13.632 3.36931 13.6935C3.39402 13.755 3.4307 13.811 3.47722 13.8582C3.52375 13.9053 3.57918 13.9428 3.64031 13.9684C3.70144 13.994 3.76704 14.0071 3.8333 14.0071C3.89957 14.0071 3.96517 13.994 4.0263 13.9684C4.08742 13.9428 4.14286 13.9053 4.18938 13.8582C4.23591 13.811 4.27259 13.755 4.29729 13.6935C4.322 13.632 4.33424 13.5663 4.3333 13.5V2.50001C4.33426 2.43308 4.32178 2.36665 4.29659 2.30464C4.2714 2.24263 4.23402 2.18631 4.18667 2.13902C4.13931 2.09172 4.08294 2.05441 4.0209 2.02931C3.95886 2.0042 3.89241 1.9918 3.82549 1.99284ZM12.1569 1.99545C12.027 1.99923 11.9037 2.0534 11.8131 2.14649L6.31312 7.64649C6.21939 7.74026 6.16673 7.86742 6.16673 8C6.16673 8.13259 6.21939 8.25975 6.31312 8.35352L11.8131 13.8535C11.8592 13.9015 11.9144 13.9398 11.9754 13.9662C12.0365 13.9926 12.1022 14.0065 12.1687 14.0072C12.2353 14.0079 12.3012 13.9953 12.3628 13.9701C12.4244 13.945 12.4804 13.9078 12.5274 13.8608C12.5745 13.8137 12.6116 13.7578 12.6368 13.6962C12.6619 13.6346 12.6745 13.5686 12.6738 13.5021C12.6732 13.4356 12.6592 13.3699 12.6328 13.3088C12.6064 13.2477 12.5681 13.1926 12.5202 13.1465L7.37367 8L12.5202 2.85352C12.5923 2.78327 12.6415 2.69288 12.6614 2.59418C12.6814 2.49547 12.671 2.39306 12.6317 2.30034C12.5925 2.20761 12.5262 2.1289 12.4414 2.0745C12.3567 2.0201 12.2575 1.99255 12.1569 1.99545Z"
        fill="#5B5B5B"
      />
    </svg>
  );
};

export default SvgFirstLastArrow;
